import axios from "axios";
import { BACKEND_URL } from "./apiConfig";
import { log } from "../utils/logger";
    


// Get eshop operating schedule
export async function getSchedules(): Promise<any> {
    try {
        const response = await axios.get(`${BACKEND_URL}/eshop/schedule`, {
            headers: {
                Accept: '*/*',
            },
        });
        return response;
    } catch (error: any) {
        throw new Error(`Error ${error.response.status}: ${error.response.statusText}`);
    }
}
